export interface FbState {
  templateOrderStatus: boolean;
  idBOT: string;
  collection: string;
}

export const initialFbState: FbState = {
  templateOrderStatus: false,
  idBOT: '',
  collection: ''
};
